import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/api';
import type { BranchAbsencePolicyDto } from '../types/api-responses';

/**
 * AB#2024 — per-branch break/absence policy (caps + override). Read for the
 * settings form + the add-break allowance hint; write from the settings modal.
 */
export function useBranchAbsencePolicyQuery(branchId: number | null) {
    return useQuery({
        queryKey: ['branch-absence-policy', branchId] as const,
        queryFn: () => apiService.getBranchAbsencePolicy(branchId!),
        enabled: branchId != null,
        staleTime: 300_000,
    });
}

export function useSetBranchAbsencePolicyMutation(branchId: number) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload: BranchAbsencePolicyDto) =>
            apiService.updateBranchAbsencePolicy(branchId, payload),
        onSuccess: (data) => {
            queryClient.setQueryData(['branch-absence-policy', branchId], data);
        },
    });
}
